import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * POST `…/amendment/{amendmentId}/reject`。body 含 rejectReason＋updatedAt。
 *
 * @param {string} workOrderId
 * @param {string} amendmentId
 * @param {object} payload
 */
export async function rejectWorkOrderAmendment(
  workOrderId,
  amendmentId,
  payload,
) {
  const { data: raw } = await request.post(
    `/mom/work-order/${workOrderId}/amendment/${amendmentId}/reject`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
